// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AdvancesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/advances
 *
 * Returns payroll advances for a period, optionally filtered by user.
 * Includes advances list, summary grouped by user, and total amount.
 */
import type { Payroll_AdvanceUserSummaryRow } from './Payroll_AdvanceUserSummaryRow'
import type { Payroll_PeriodAdvanceRow } from './Payroll_PeriodAdvanceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_AdvancesResponseDados {
advances: Payroll_PeriodAdvanceRow[]
summary_by_user: Payroll_AdvanceUserSummaryRow[]
total_advances: number
}

export type Payroll_AdvancesResponse = ApiResponse<Payroll_AdvancesResponseDados>;

registerResponseContract('Payroll_AdvancesResponse', {
  advances: {
    type: 'array',
    required: true,
    items: {
      id:                             { type: 'number',  required: true },
      payroll_period_id:              { type: 'number',  required: true },
      user_id:                        { type: 'string',  required: true },
      franchise_id:                   { type: 'number',  required: true },
      recebimento_id:                 { type: 'number',  required: true },
      generated_despesa_id:           { type: 'number',  required: false },
      notes:                          { type: 'string',  required: false },
      created_at:                     { type: 'string',  required: true },
      created_by:                     { type: 'string',  required: true },
      recebimento_valor:              { type: 'number',  required: false },
      recebimento_data:               { type: 'string',  required: false },
      recebimento_forma_pagamento_id: { type: 'number',  required: false },
      forma_pagamento_nome:           { type: 'string',  required: false },
      compromisso_id:                 { type: 'number',  required: false },
      orcamento_cliente_id:           { type: 'number',  required: false },
      cliente_nome:                   { type: 'string',  required: false },
      amount:                         { type: 'number',  required: false },
    },
  },
  summary_by_user: {
    type: 'array',
    required: true,
    items: {
      user_id:        { type: 'string',  required: true },
      advance_count:  { type: 'number',  required: true },
      total_advances: { type: 'string',  required: false },
    },
  },
  total_advances:  { type: 'number',  required: true },
})
